import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';

const useStyles = buildUseStyles('Layout', ((theme) => ({
  questions: {
    paddingTop: theme.spacing(1),
  },
  section: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.facet.mediumGray}`,
  },
  nestedQuestion: {
    paddingLeft: theme.spacing(2),
  },
  lastSection: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
})));

const Layout = () => {
  const classes = useStyles();

  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <PageContentContainer>
      <PageContentTop
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <Box className={classes.questions}>
        <Box className={classes.section}>
          <MetaField attr={'finraAffiliatedQuestion'} />
          <MetaField attr={'finraFirmName'} />
        </Box>

        <Box className={classes.section}>
          <MetaField attr={'publiclyTradedCompanyQuestion'} />
          <MetaField attr={'companySymbols'} />
        </Box>

        <Box className={classes.section}>
          <MetaField attr={'politicalExposureQuestion'} />
          <MetaField attr={'politicalOrganization'} />
          <MetaField attr={'immediateFamilyMemberPoliticallyExposed'} />
        </Box>

        <Box className={classes.section}>
          <MetaField attr={'duplicateStatementsQuestion'} />
          <MetaField attr={'interestedPartyName'} />
          <MetaField attr={'interestedPartyAddressLine1'} />
          <MetaField attr={'interestedPartyAddressLine2'} />
          <MetaField attr={'interestedPartyCity'} />
          <MetaField attr={'interestedPartyState'} />
          <MetaField attr={'interestedPartyZipCode'} />
        </Box>

        <Box className={classes.lastSection}>
          <MetaField attr={'backupWithholdingsQuestion'} />
          <Box className={classes.nestedQuestion}>
            <MetaField attr={'backupWithholdingsConfirmation'} />
          </Box>
        </Box>
      </Box>
    </PageContentContainer>
  );
};

export default Layout;
